import React, { FC } from "react";
import { ReactComponent as RemoveSVG } from "go-core/images/svg/actions/remove.svg";
import { ReactComponent as AttachmentSVG } from "../../images/svg/attachment.svg";
import { FileAttachmentApi } from "../../services/Api/Organization/types";
import { onDownloadAttachment } from "./services/attachment";

interface Props {
	attachment: FileAttachmentApi;
	onRemoveFile: () => void;
}

const AttachmentItemForm: FC<Props> = ({ attachment, onRemoveFile }) => {
	return (
		<div className="attachments-item d-flex align-items-center">
			<div className="d-flex align-items-center">
				<div className="attachments-item-icon">
					<AttachmentSVG />
				</div>
				<a href="javascript:" onClick={() => onDownloadAttachment(attachment)}>
					{attachment.name}
				</a>
			</div>
			<RemoveSVG className="ms-auto remove-icon" onClick={onRemoveFile} />
		</div>
	);
};

export default AttachmentItemForm;
